import React from 'react';
import styled from 'styled-components';
import { Typography } from '@material-ui/core';
import {
	ComposedChart,
	Line,
	Area,
	XAxis,
	YAxis,
	Tooltip,
	ResponsiveContainer,
} from 'recharts';

/* eslint-disable indent */
const Root = styled.div`
	.tooltip {
		padding: 20px;
		background-color: ${(props) =>
			props.theme.palette.blocks.graph.overlay.backgroundColor};

		.tooltip__headline {
			display: flex;
			font-size: 60px;
			line-height: 1;

			span {
				font-size: 14px;
				font-weight: bold;
			}
		}

		.tooltip__content {
			margin: 20px 0 0 0;
			padding: 0;
			list-style: none;

			& > li:not(:first-child) {
				margin-top: 10px;
			}
		}
	}
`;

const FlowGraphToolTip = (props) => {
	const { active, streamGraphUnit, payload } = props;

	if (!payload[0]) {
		return <Root>Keine Daten...</Root>;
	}

	if (active) {
		return (
			<Root>
				<div className="tooltip">
					<Typography variant="h5" className="tooltip__headline">
						{payload[0].payload.week_number} <span>Kalenderwoche</span>
					</Typography>
					<ul className="tooltip__content">
						{payload.map((r) => (
							<li key={r.name}>
								{`${r.name} : ${r.value.toFixed(2)}`} {streamGraphUnit}
							</li>
						))}
					</ul>
				</div>
			</Root>
		);
	}

	return null;
};

const ActiveDot = (props) => {
	const { cx, cy, fill } = props;
	return <circle cx={cx} cy={cy} r={10} fill="black" stroke={fill} strokeWidth={10} />;
};

const FlowGraph = ({
	boolHidden,
	data,
	activeCaseData,
	activeCase,
	streamGraphUnit = 'kW',
}) => (
	// activeCase True = Netzentgelte
	// activeCase False = Eigenverbrauch
	// target_load / Zielsetzung is a special requirement and Line-Graph used by Netzentgelte.
	<ResponsiveContainer width="100%" height={600} minWidth={0}>
		<ComposedChart data={data[activeCase ? [0] : [1]]}>
			{activeCaseData
				.filter((cdata) => cdata.dataKey !== 'target_load')
				.map((cdata) => (
					<Area
						key={Math.random()}
						type="monotone"
						dataKey={`${cdata.dataKey}`}
						stroke={`${cdata.color}`}
						fill={`${cdata.color}`}
						unit={` ${cdata.unit}`}
						name={`${cdata.name}`}
						hide={boolHidden[`${cdata.dataKey}`]}
						fillOpacity={1}
						activeDot={<ActiveDot />}
					/>
				))}

			<Line
				type="monotone"
				name="Zielleistung"
				dataKey="target_load"
				stroke="#ffffff"
				unit="kW"
				dot={false}
				hide={boolHidden.target_load}
			/>

			<YAxis mirror interval={0} />

			<XAxis dataKey="week_number" tick={false} />

			<Tooltip
				content={<FlowGraphToolTip streamGraphUnit={streamGraphUnit} />}
				cursor={{ stroke: '#ffffff', strokeWidth: 1, strokeDasharray: '6' }}
			/>
		</ComposedChart>
	</ResponsiveContainer>
);

export default FlowGraph;
